import React from "react";
import {
  AffinityLogomark,
  VodafoneLogo,
  DWSLogotypeLight,
} from "../../../../index";
import { parseBrandFromUrl } from "../../../helpers/brand";

export function SubNavLogo(props: React.SVGProps<SVGSVGElement>) {
  const brand = parseBrandFromUrl();
  switch (brand) {
    case "VODAFONE":
      return <VodafoneLogo {...props} width={280} />;
    case "DWS":
      return <DWSLogotypeLight />;
    case "AFFINITY":
    default:
      return <AffinityLogomark {...props} />;
  }
}
